import braintree from "braintree-web";
import { Api } from "../../Services/Api";
import { AddPaymentMethodFunnel } from "./AddPaymentMethodFunnel";
import { LogEvent } from "../../utils/LogEvent";

/** Singleton instance of Braintree Client SDK. */
let btClient: braintree.Client | null;

/**
 * Loads the Braintree SDK. There are two parts each of which could fail;
 * 1) Client Token (from API)
 * 2) Braintree SDK
 */
const MakeBtClient = async () => {

    LogEvent.GooglePayDebug("Get Client Token");

    // 1) Client Token
    const tokenResult = await Api.PaymentV2.GetClientToken();

    if (!tokenResult.isSuccess) {
        AddPaymentMethodFunnel.ApiError("Get Token", tokenResult, false);
        LogEvent.GooglePayDebug("Get Client Token Failed", { Error: JSON.stringify(tokenResult) });
        return null;
    }

    LogEvent.GooglePayDebug("Get Client Token Succeeded");
    LogEvent.GooglePayDebug("Creating Braintree Client");

    // 2) Braintree SDK
    try {
        const token = tokenResult.value;

        btClient = await braintree.client.create({
            authorization: token
        });
    }
    catch (error) {
        AddPaymentMethodFunnel.Exception("Braintree Client", error, false);
        LogEvent.GooglePayDebug("Creating Braintree Client Failed", { Error: JSON.stringify(error) });
        return null;
    }

    LogEvent.GooglePayDebug("Creating Braintree Client Succeeded");
    return btClient;
}

/**
 * Returns the exisiting Braintree client if any, or create a new one.
 */
export const GetOrMakeBraintreeClient = async () => {

    LogEvent.GooglePayDebug("GetOrMakeBraintreeClient");

    if (!btClient) {
        LogEvent.GooglePayDebug("No Braintree Client, creating one");
        btClient = await MakeBtClient();
    }

    LogEvent.GooglePayDebug("Returning Braintree Client");
    return btClient;
}